var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWave1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "visual",
    viewBox: "0 0 1700 120",
    width: 1700,
    height: 120,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 59L35.5 63.5C71 68 142 77 212.8 74.2C283.7 71.3 354.3 56.7 425.2 49C496 41.3 567 40.7 637.8 45.2C708.7 49.7 779.3 59.3 850.2 64.8C921 70.3 992 71.7 1062.8 65.3C1133.7 59 1204.3 45 1275.2 39.8C1346 34.7 1417 38.3 1487.8 39.8C1558.7 41.3 1629.3 40.7 1664.7 40.3L1700 40L1700 121L1664.7 121C1629.3 121 1558.7 121 1487.8 121C1417 121 1346 121 1275.2 121C1204.3 121 1133.7 121 1062.8 121C992 121 921 121 850.2 121C779.3 121 708.7 121 637.8 121C567 121 496 121 425.2 121C354.3 121 283.7 121 212.8 121C142 121 71 121 35.5 121L0 121Z",
    fill: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "miter"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWave1);
export default __webpack_public_path__ + "static/media/wave1.05ed0aac96d9b868c023d965952ea7c7.svg";
export { ForwardRef as ReactComponent };